import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu12",
  "use": "icon-menu12-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52 52\" id=\"icon-menu12\">\r\n<polygon fill=\"currentColor\" points=\"44.54,4.789 44.484,4.789 38.896,4.789 38.896,0 5.831,0 5.831,15.822 38.896,15.822 38.896,11.544 44.484,11.544 \r\n\t44.484,20.793 19.163,20.793 19.163,24.971 19.163,25.338 19.163,51.198 27.607,51.198 27.607,25.338 44.484,25.338 44.54,25.338 \r\n\t47.862,25.338 47.862,4.789 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol